import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import SortableOption from "./sortable-option";

export default function OptionsList({
  options,
  onOptionChange,
  onOptionSelect,
  onOptionRemove,
  onOptionsReorder,
  disabled = false,
  language = "en",
  isSurvey = false,
  radioName, // Added radioName prop
}) {
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 8 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      const oldIndex = options.findIndex((option) => option.id === active.id);
      const newIndex = options.findIndex((option) => option.id === over.id);
      const newOptions = arrayMove(options, oldIndex, newIndex);
      onOptionsReorder(newOptions);
    }
  };

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
      modifiers={[restrictToVerticalAxis]}
    >
      <SortableContext
        items={options.map((option) => option.id)}
        strategy={verticalListSortingStrategy}
      >
        <div className="space-y-2">
          {options.map((option) => (
            <SortableOption
              key={option.id}
              option={option}
              onChange={(text) => onOptionChange(option.id, text)}
              onSelectCorrect={onOptionSelect}
              onRemove={() => onOptionRemove(option.id)}
              disabled={disabled}
              language={language}
              isSurvey={isSurvey}
              radioName={radioName} // Pass radioName to SortableOption
            />
          ))}
        </div>
      </SortableContext>
    </DndContext>
  );
}
